import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "5",
  viewBox: "0 0 23 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "2.5",
  cy: "2.54562",
  r: "2.5",
  fill: "#878787"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "11.5",
  cy: "2.54562",
  r: "2.5",
  fill: "#878787"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20.5",
  cy: "2.54562",
  r: "2.5",
  fill: "#878787"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'threeDots',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})